function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M163.116 19.622a5.181 5.181 0 005.184 5.184v8.087a5.182 5.182 0 00-5.184 5.184 5.181 5.181 0 005.184 5.184v8.087a5.43 5.43 0 10.182 10.86v8.062a5.262 5.262 0 100 10.523v8.062a5.262 5.262 0 100 10.523v8.087a5.247 5.247 0 00-5.249 5.249 5.25 5.25 0 005.249 5.249v8.087a5.265 5.265 0 00-5.262 5.262 5.263 5.263 0 005.262 5.262v8.061a5.261 5.261 0 100 10.524v8.061a5.185 5.185 0 00-5.184 5.184h-8.243a5.276 5.276 0 00-10.55 0h-8.061a5.261 5.261 0 10-10.523 0h-8.062a5.261 5.261 0 10-10.523 0h-8.061a5.262 5.262 0 10-10.524 0H80.69a5.262 5.262 0 10-10.524 0H62.21a5.251 5.251 0 00-5.25-5.249 5.25 5.25 0 00-5.248 5.249h-8.217a5.251 5.251 0 00-5.249-5.249 5.25 5.25 0 00-5.248 5.249h-8.088a5.262 5.262 0 10-10.523 0H6.325a5.184 5.184 0 00-5.184-5.184v-8.191a5.185 5.185 0 100-10.368v-8.217a5.26 5.26 0 100-10.523v-8.088a5.25 5.25 0 003.711-8.96 5.25 5.25 0 00-3.712-1.537v-8.087a5.262 5.262 0 100-10.524v-8.061a5.262 5.262 0 000-10.524V62.21a5.262 5.262 0 000-10.524v-8.217a5.184 5.184 0 000-10.368v-8.217a5.184 5.184 0 100-10.368V6.3a5.184 5.184 0 005.185-5.184h8.06a5.262 5.262 0 0010.524-.078h8.087a5.184 5.184 0 0010.369 0h8.216a5.184 5.184 0 0010.368 0h8.088a5.262 5.262 0 0010.523 0h8.061a5.326 5.326 0 1010.654 0h8.061a5.26 5.26 0 1010.523 0h8.062a5.185 5.185 0 1010.368 0h8.061a5.276 5.276 0 0010.549 0h8.062a5.185 5.185 0 005.184 5.184v8.165a5.184 5.184 0 00-5.029 5.236z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.707 14.334H14.334v70.373h70.373V14.334z",
  fill: "#F2B952"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M155.081 14.334H84.707v70.373h70.374V14.334z",
  fill: "#3B4AB6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M84.707 84.707H14.334v70.374h70.373V84.707z",
  fill: "#3B4AB6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M155.081 84.707H84.707v70.374h70.374V84.707z",
  fill: "#F2B952"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M84.707 84.707v70.374h70.374a70.375 70.375 0 00-70.374-70.374z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M84.707 84.707v70.374H14.334a70.4 70.4 0 0170.373-70.374z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.334 33.956c7.024 0 7.024 4.924 14.178 4.924 7.154 0 7.025-5.002 14.075-5.002 7.05 0 6.92 5.002 13.971 5.002 7.05 0 7.024-5.002 14.075-5.002 7.05 0 7.128 5.002 14.074 5.002",
  stroke: "#3B4AB6",
  strokeWidth: 7.439,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M155.081 33.956c-7.025 0-7.025 4.924-14.075 4.924-7.05 0-7.024-4.925-13.997-4.925-6.972 0-7.102 4.925-14.126 4.925-7.025 0-7.051-5.002-14.101-5.002-7.05 0-7.024 5.002-14.075 5.002",
  stroke: "#EFB9B9",
  strokeWidth: 7.439,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M14.334 60.809c7.024 0 7.024 4.977 14.075 4.977 7.05 0 7.024-4.977 14.074-4.977s7.025 4.977 14.075 4.977c7.05 0 7.024-4.977 14.075-4.977 7.05 0 7.024 4.977 14.074 4.977M155.081 60.809c-7.025 0-7.025 4.977-14.075 4.977-7.05 0-7.024-4.977-13.997-4.977-6.972 0-7.024 4.977-14.049 4.977-7.024 0-7.05-4.977-14.1-4.977s-7.025 4.977-14.075 4.977",
  stroke: "#fff",
  strokeWidth: 7.439,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M14.334 103.681c7.024 0 7.024 4.925 14.178 4.925 7.154 0 6.921-4.925 13.971-4.925s7.025 5.003 14.075 5.003c7.05 0 7.024-5.003 14.075-5.003 7.05 0 7.128 4.925 14.074 4.925",
  stroke: "#EFB9B9",
  strokeWidth: 7.439,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M155.081 103.681c-7.025 0-7.025 5.003-14.075 5.003-7.05 0-7.024-5.003-13.997-5.003-6.972 0-7.024 5.003-14.049 5.003-7.024 0-7.128-5.003-14.178-5.003-7.05 0-7.024 4.925-14.075 4.925M14.334 130.431c7.024 0 7.024 5.002 14.075 5.002 7.05 0 7.024-5.002 14.074-5.002s7.025 5.002 14.075 5.002c7.05 0 7.024-5.002 14.075-5.002 7.05 0 7.024 5.002 14.074 5.002",
  stroke: "#3B4AB6",
  strokeWidth: 7.439,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M155.081 130.431c-7.025 0-7.025 5.002-14.075 5.002-7.05 0-7.024-5.002-13.997-5.002-6.972 0-7.024 5.002-14.049 5.002-7.024 0-7.05-5.002-14.1-5.002s-7.025 5.002-14.075 5.002",
  stroke: "#EFB9B9",
  strokeWidth: 7.439,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M88.958 98.834l3.733 56.247H76.724l3.733-56.247h8.501z",
  fill: "#F2B952"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M88.725 50l1.244 9.824H79.472L80.69 50h8.035zM114.619 84.707a29.909 29.909 0 01-29.912 29.912 29.91 29.91 0 01-29.912-29.912h59.824z",
  fill: "#EA7049"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M54.795 84.707a29.912 29.912 0 0159.824 0H54.795z",
  fill: "#EFB9B9"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M86.807 14.334h-4.2V50h4.2V14.334z",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M86.807 14.334h-4.2v4.329h4.2v-4.33zM86.807 22.991h-4.2v4.329h4.2V22.99zM86.807 31.804h-4.2v4.329h4.2v-4.329zM86.807 40.902h-4.2v4.329h4.2v-4.329z",
  fill: "#EA7049"
});

function SvgBerlin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 169 169",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default __webpack_public_path__ + "static/berlin.cc579a4b.svg";
export { SvgBerlin as ReactComponent };